import { useNode, useEditor } from "@craftjs/core";
import React, {
  useRef,
  useState,
  useEffect,
  Children,
  useContext,
} from "react";
import { CustomHtmlSettings } from "./settings";
import icon from "./icon";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";
import CMSIcon from "./cms-icon";
import { INPUT_LIMITS } from "../../input-limits";
import { waitForElement } from "../../dom";
import { GrigoraDashboardContext } from "../../dashboard/context";
import { CMSHTMLSettings } from "./cms-settings";
import { RawHTML } from "../../raw-html";

export const CustomHtml = (props) => {
  const {
    id,
    connectors: { connect, drag },
    selected,
    actions: { setProp },
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const { editorDocument } = useContext(GrigoraDashboardContext) ?? {};

  const [showPreview, setShowPreview] = useState(false);
  const [height, setHeight] = useState(48);

  const {
    actions: { selectNode },
  } = useEditor();

  const { content } = props;
  const textareaRef = useRef(null);
  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-custom-html": true,
      [`custom-html-${id}`]: id,
      "is-preview-active": showPreview,
      "is-selected": selected,
    },
    blockProps.className,
  );

  useEffect(() => {
    if (!showPreview) {
      waitForElement(editorDocument, `.custom-html-${id} textarea`).then(
        (el) => {
          el.style.height = "5px";
          el.style.height = el.scrollHeight + "px";
        },
      );
    }
  }, [showPreview]);

  useEffect(() => {
    if (textareaRef?.current?.scrollHeight) {
      textareaRef.current.style.height =
        textareaRef.current.scrollHeight + "px";
    }
  }, []);

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      onClick={() => selected}
      className={wrapperClass}
      onFocus={() => {
        selectNode(id);
      }}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <button
        contentEditable={false}
        className={classnames({
          "preview-btn select-none": true,
          active: showPreview,
        })}
        onClick={() => {
          setShowPreview(!showPreview);
        }}
      >
        {showPreview ? <>HTML</> : <>Preview</>}
      </button>
      {showPreview ? (
        <RawHTML key={content}>{content}</RawHTML>
      ) : (
        <textarea
          minLength={INPUT_LIMITS["custom-code"].minlength}
          maxLength={INPUT_LIMITS["custom-code"].maxlength}
          ref={textareaRef}
          rows={1}
          className="custom-html-textarea grigora-custom-scrollbar"
          value={content}
          placeholder="Custom HTML"
          onInput={(e) => {
            e.target.style.height = "5px";
            e.target.style.height = e.target.scrollHeight + "px";
          }}
          onChange={(e) => {
            if (e.target.value === "") {
              e.target.style.height = "auto";
            }
            setProp((props) => (props.content = e.target.value), 500);
          }}
        ></textarea>
      )}
    </div>
  );
};

// To Avoid Mangling in Production
CustomHtml.displayName = "CustomHtml";

CustomHtml.craft = {
  name: "Custom HTML",
  props: {},
  related: {
    settings: CustomHtmlSettings,
    CMSsettings: CMSHTMLSettings,
    supports: [
      "grigora/directory-conditional",
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    icon: icon,
    CMSIcon: CMSIcon,
    keywords: ["HTML", "Custom HTML"],
  },
  custom: {
    name: "Custom HTML",
    slug: "grigora/custom-html",
  },
};
